import { BrowserModule } from '@angular/platform-browser';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AssociateModule } from './associate/associate.module';
import { OrganizationModule } from './organization/organization.module';
import { PublishingModule } from './publishing/publishing.module';
import { TrainingModule } from './training/training.module'
import { ExportingHubModule } from './exporting-hub/exporting-hub.module';
import { VendorsModule } from './vendors/vendors.module'
import { ProductsModule } from './products/products.module'
import 'rxjs/Rx';

import { NgxCaptureModule } from 'ngx-capture';





import { IonicAngular4CacheModule } from 'ionic-angular4-cache';
import { ErrorHandler, Injectable } from '@angular/core';

// import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
    MatAutocompleteModule,
    MatToolbarModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatSidenavModule,
    MatSelectModule,
    MatDialogModule,
    MatDatepickerModule,
    MAT_DATE_LOCALE,
    MatNativeDateModule,
    MatSnackBarModule,
    MatSortModule,
    MatPaginatorModule,
    MatSliderModule,
    MatStepperModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatCheckboxModule
} from '@angular/material';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { SharedModule } from './shared/shared.module';
import { WorkGroupsModule } from './work-groups/work-groups.module';
// import { TreeModule } from 'angular-tree-component';
import { TokenInterceptor } from './shared/services/auth/token.interceptor';
import { MyHammerConfig } from './shared/services/hammer.config';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// import { Ng2SearchPipeModule } from 'ng2-search-filter';


import { AppComponent } from './app.component';
import { LoginComponent } from './main/login/login.component';
import { Configuration } from './app.constants';
import { AuthService } from './shared/services/auth/auth.service';
import { ToastService } from './shared/services/toast.service';
import { GetDataService } from './shared/services/get-data.service';
import { AuthGuard } from './shared/services/auth/auth.guard';
import { MobileNavService } from './shared/services/mobile-nav.service';
// import { StaticValueService } from './shared/services/static-value.service'

import { HeaderComponent } from './main/header/header.component';
import { HomeComponent } from './main/home/home.component';
import { SidebarComponent } from './main/sidebar/sidebar.component';
import { MainComponent } from './main/main.component';
import { RegisterComponent } from './admin/register/register.component';
import { CreateAclComponent } from './admin/create-acl/create-acl.component';
import { StaticValueService } from './shared/services/static-value.service'
// import { FileUploaderModule } from 'ng4-file-upload/file-uploader.module';
import { StaticDataResolver } from './shared/services/staticData.resolver'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DisclaimerComponent } from './main/disclaimer/disclaimer.component';
import { SignUpComponent, SignupConfirmDialogComponent } from './main/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './main/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './main/reset-password/reset-password.component';

// internationalization
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { LinkedinSignupWaitComponent } from './main/linkedin-signup-wait/linkedin-signup-wait.component';
import { MobileFooterComponent } from './main/mobile-footer/mobile-footer.component';
import { GlossaryComponent } from './main/static-web/glossary/glossary.component';
import { FaqsComponent } from './main/static-web/faqs/faqs.component';
import { GuideComponent } from './main/static-web/guide/guide.component';
import { AssessVisuComponent } from './main/assess-visu/assess-visu.component';
import { Ng2ImgToolsModule } from 'ng2-img-tools';
import { SentEmailListComponent } from './main/sent-email-list/sent-email-list.component';
import { Page404Component } from './main/page404/page404.component';
import { Page500Component } from './main/page500/page500.component';
import { PrintPlansComponent } from './main/print-plans/print-plans.component';
import { HttpCancelService } from '../app/shared/services/httpCancelService';
import { ManageHttpInterceptor } from '../app/shared/services/interceptor/managehttp.interceptor';
import { PopupReportComponent } from './exporting-hub/popup-generateReport/popup-report.component';
import { ExportHubLogsComponent } from './export-hub-logs/export-hub-logs.component';
import { WelcomeDashboardComponent } from './main/welcome-dashboard/welcome-dashboard.component';
import { SupplierSummaryExportComponent } from './supplier-summary-export/supplier-summary-export.component';

// import { SystemDashboardComponent } from './system-dashboard/system-dashboard.component';

// import { UIErrorHandler } from './ui-error-handler';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// overriding hammerconfing to enable vertival swipe
export class HammerConfig extends HammerGestureConfig {
    buildHammer(element: HTMLElement) {
        const mc = new Hammer(element, {
            touchAction: 'pan-y'
        });
        return mc;
    }
}

export class UIErrorHandler extends ErrorHandler {
    constructor() {
        super();
    }
    handleError(error) {
        super.handleError(error);
        // alert(`Error occurred:${error.message}`);
    }
}

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'welcome', component: WelcomeDashboardComponent },
    { path: 'assessVisu/:assocId/:nonce', component: AssessVisuComponent },
    { path: 'printPlans/:assocId/:assessmentId/:nonce', component: PrintPlansComponent },
    { path: 'sign-up/:id', component: SignUpComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'linkedinSignUpWait', component: LinkedinSignupWaitComponent },
    { path: 'password-reset/:id/:random-string', component: ResetPasswordComponent },
    { path: 'password-reset/:id/:random-string/:mode', component: ResetPasswordComponent },
    { path: 'disclaimer', component: DisclaimerComponent },
    { path: 'sentemails', component: SentEmailListComponent },
    { path: 'glossary', component: GlossaryComponent },
    { path: 'guide', component: GuideComponent },
    { path: 'FAQs', component: FaqsComponent },
    { path: '404', component: Page404Component },
    { path: '500', component: Page500Component },
    {
        path: 'home',
        component: MainComponent,
        resolve: {
            staticData: StaticDataResolver
        },
        canActivate: [AuthGuard],
        children: [
            {
                path: 'associate',
                loadChildren: 'app/associate/associate.module#AssociateModule',
                data: { page: 'associate' }
            }, {
                path: 'organization',
                loadChildren: 'app/organization/organization.module#OrganizationModule',
                data: { page: 'organization' }
            },
            {
                path: 'legal-entity',
                loadChildren: 'app/legal-entity/legal-entity.module#LegalEntityModule'
            },
            {
                path: 'talent-management',
                loadChildren: 'app/talent-management/talent-management.module#TalentManagementModule'
            }, {
                path: 'list',
                loadChildren: 'app/list/list.module#ListModule'
            }, {
                path: 'working-group',
                loadChildren: 'app/work-groups/work-groups.module#WorkGroupsModule'
            }, {
                path: 'super-admin',
                loadChildren: 'app/admin/register/register.module#RegisterModule'
            }, {
                path: 'publishing',
                loadChildren: 'app/publishing/publishing.module#PublishingModule'
            }, {
                path: 'training',
                loadChildren: 'app/training/training.module#TrainingModule'
            }, {
                path: 'export-hub',
                loadChildren: 'app/exporting-hub/exporting-hub.module#ExportingHubModule'
            }, {
                path: 'vendors',
                loadChildren: 'app/vendors/vendors.module#VendorsModule',
                data: { page: 'vendors' }
            },
            {
                path: 'products',
                loadChildren: 'app/products/products.module#ProductsModule',
                data: { page: 'products' }
            }, {
                path: 'api-access',
                loadChildren:'app/api-access/api-access.module#ApiAccessModule'
            },
            {
                path: 'system-dashboard',
                loadChildren:'app/system-dashboard/system-dashboard.module#SystemDashboardModule'

            },
            {
                path: 'gtin',
                loadChildren:'app/gtin/gtin.module#GtinModule'
            },
            {
                path:'logs',
                component:ExportHubLogsComponent
            },
            {
                path: 'supplier-summary-export',
                component: SupplierSummaryExportComponent
            }
        ]
    }
];

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HeaderComponent,
        HomeComponent,
        SidebarComponent,
        MainComponent,
        RegisterComponent,
        DisclaimerComponent,
        SignUpComponent,
        ForgotPasswordComponent,
        SignupConfirmDialogComponent,
        ResetPasswordComponent,
        LinkedinSignupWaitComponent,
        MobileFooterComponent,
        GlossaryComponent,
        FaqsComponent,
        GuideComponent,
        AssessVisuComponent,
        SentEmailListComponent,
        Page404Component,
        Page500Component,
        PrintPlansComponent,
        PopupReportComponent,
        ExportHubLogsComponent,
        SupplierSummaryExportComponent,
        WelcomeDashboardComponent,

    ],
    entryComponents: [SignupConfirmDialogComponent, PopupReportComponent],
    imports: [
        AssociateModule,
        OrganizationModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
         BrowserModule.withServerTransition({appId: 'for-visu-printint'}), // <-- enabling server side rendering
        BrowserModule,
        Ng2ImgToolsModule,
        RouterModule.forRoot(
            routes
        ),
        NgbModule.forRoot(),
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MatAutocompleteModule,
        MatToolbarModule,
        MatCardModule,
        MatInputModule,
        MatButtonModule,
        MatSidenavModule,
        MatSelectModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSnackBarModule,
        MatSortModule,
        MatPaginatorModule,
        MatSliderModule,
        BrowserModule,
        MatProgressSpinnerModule,
        TextMaskModule,
        MatStepperModule,
        MatCheckboxModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        LoadingBarHttpClientModule,
        // Ng2SearchPipeModule,
        SharedModule,
        WorkGroupsModule,
        IonicAngular4CacheModule.forRoot(),
        MatTooltipModule,
        TrainingModule,
        // NgxMatSelectSearchModule,
        // MatFormFieldModule

    ],
    providers: [
        Configuration,
        AuthService,
        ToastService,
        AuthGuard,
        GetDataService,
        StaticValueService,
        MobileNavService,
        StaticDataResolver,
        HttpCancelService,
        { provide: HTTP_INTERCEPTORS, useClass: ManageHttpInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        // {provide: ErrorHandler, useClass: UIErrorHandler}
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
